<template>
  <div>
    <div v-if="!is_registered">
      <EventManagementRegisterForm
        @registration-success="onRegistrationSuccess"
      />
    </div>
    <div v-else>
      <RegisteredForm
        :ticket-data="ticketData"
        :response-message="responseMessage"
      />
    </div>
  </div>
</template>

<script>
import EventManagementRegisterForm from './components/event-management-register.vue'
import RegisteredForm from './components/registered-form.vue'

export default {
  name: 'EventManagementMain',
  components: {
    EventManagementRegisterForm,
    RegisteredForm
  },
  data() {
    return {
      is_registered: false,
      ticketData: null,
      responseMessage: null,
      event_mgt_id: null
    }
  },
  mounted() {
    // Get event ID from route query
    this.event_mgt_id = this.$route.query.event_mgt_id

    // Get cookies
    const cookieRegistered = this.getCookie('is_registered')
    const cookieEventId = this.getCookie('event_mgt_id')

    // Check if user is already registered for this same event
    if (cookieRegistered === 'true' && cookieEventId === this.event_mgt_id) {
      this.is_registered = true

      const savedTicket = this.getCookie('ticketData')
      if (savedTicket) {
        try {
          this.ticketData = JSON.parse(decodeURIComponent(savedTicket))
        } catch (e) {
          console.error('Failed to parse ticketData cookie:', e)
          this.ticketData = null
        }
      }
    } else {
      // If new event, clear old registration cookies
      this.deleteCookie('is_registered')
      this.deleteCookie('ticketData')
      this.deleteCookie('event_mgt_id')
    }
  },
  methods: {
    onRegistrationSuccess(response) {
      this.ticketData = response.data
      this.responseMessage = response.message
      this.is_registered = true

      // Save registration details to cookies
      this.setCookie('is_registered', 'true', 7)
      this.setCookie('ticketData', encodeURIComponent(JSON.stringify(response.data)), 7)
      this.setCookie('event_mgt_id', this.event_mgt_id, 7)
    },

    // --- Cookie helpers ---
    getCookie(name) {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) return parts.pop().split(';').shift()
      return null
    },

    setCookie(name, value, days) {
      const d = new Date()
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
      const expires = `expires=${d.toUTCString()}`
      document.cookie = `${name}=${value}; ${expires}; path=/`
    },

    deleteCookie(name) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
    }
  }
}
</script>
